<template>
  <modal v-model="value.show" :klass="'ls-modal-large'">
    <div slot="content">
      <div class="ls-modal-header">
        <button type="button" close-modal data-dismiss="modal">&times;</button>
        <h4 class="ls-modal-title">{{ $t('entries.add_entry') }}</h4>
      </div>
      <form @submit.prevent="validateBeforeSubmit" class="ls-form ls-form-horizontal">
        <div data-test="entries" class="ls-modal-body">
          <div class="ls-alert-warning" role="alert">
            <strong>{{ $t('application.alert.warning') }}</strong> {{ $t('entries.add_entry_message') }}
          </div>

          <authorized-link tag="create_entry">
            <p>{{ $t('entries.next_invoice_information') }}</p>
            <fieldset class="ls-md-margin-bottom row">
              <label class="ls-label col-md-3 col-xs-12" :class="{'ls-error': errors.has($t('entries.type')) }">
                <b class="ls-label-text">{{ $t('entries.type') }}</b>
                <div class="ls-custom-select">
                  <select
                    class="ls-custom"
                    data-test="entry.type"
                    v-validate="'required'"
                    v-model="newEntry.type"
                    :name="$t('entries.type')">
                    <option value="0">{{ $t('entries.addition') }}</option>
                    <option value="1">{{ $t('entries.discount') }}</option>
                  </select>
                </div>
                <small class="ls-help-message" v-show="errors.has($t('entries.type'))">{{ errors.first($t('entries.type')) }}</small>
              </label>

              <label class="ls-label col-md-4 col-xs-12" :class="{'ls-error': errors.has($t('entries.description')) }">
                <b class="ls-label-text">{{ $t('entries.description') }}</b>
                <input
                  class="ls-field"
                  type="text"
                  maxlength="40"
                  data-test="entry.description"
                  v-validate="'required'"
                  v-model="newEntry.description"
                  :placeholder="$t('entries.placeholder.add_entry')"
                  :name="$t('entries.description')">
                <small class="ls-help-message" v-show="errors.has($t('entries.description'))">{{ errors.first($t('entries.description')) }}</small>
                <char-counter v-model="newEntry.description" v-show="!errors.has($t('entries.description'))" :max="40"></char-counter>
              </label>

              <label class="ls-label col-md-3 col-xs-12" :class="{'ls-error': errors.has($t('entries.value')) }">
                <b class="ls-label-text">{{ $t('entries.value') }}</b>
                <money-input
                  autocomplete="off"
                  :value="newEntry.price"
                  @updateValue="(value) => { newEntry.price = value }"
                  v-model="newEntry.price"
                  v-validate="'required'"
                  :dataTest="'entry.price'"
                  :name="$t('entries.value')">
                </money-input>
                <small class="ls-help-message" v-show="errors.has($t('entries.value'))">{{ errors.first($t('entries.value')) }}</small>
              </label>

              <div class="btn-action ls-float-right">
                <button class="ls-btn">{{ $t('application.button.include') }}</button>
              </div>
            </fieldset>
          </authorized-link>

          <div v-if="entries.length > 0">
            <h5 class="ls-title-5">{{ $t('entries.additional_entries_next_invoice') }}</h5>
            <table class="ls-table entries-table ls-table-striped">
              <thead>
              <tr>
                <th class="ls-txt-left">{{ $t('entries.type') }}</th>
                <th class="ls-txt-left">{{ $t('entries.description') }}</th>
                <th class="ls-txt-right">{{ $t('entries.value') }}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
                <template v-for="entry in entries" :class="{'ls-color-danger': isDiscount(entry.price) }">
                  <tr v-if="entry.launched === false">
                    <td class="ls-txt-left" v-if="entry.price >= 0">{{ $t('entries.addition') }}</td>
                    <td class="ls-txt-left" v-else>{{ $t('entries.discount') }}</td>
                    <td class="ls-txt-left" >{{ entry.description }}</td>
                    <td class="ls-txt-right">R$ {{ money.parseViewValue(entry.price) }}</td>
                    <td class="ls-txt-center">
                      <authorized-link tag="destroy_entry">
                        <button v-if="!cannotBeDeleted(entry)" class="ls-btn-danger" @click.prevent="removeEntry(entry)" @keyup.enter.prevent="removeEntry(entry, description, price)">{{ $t('entries.button.remove') }}</button>
                      </authorized-link>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="ls-modal-footer">
          <button type="button" class="ls-btn ls-float-right" data-dismiss="modal" close-modal>{{ $t('application.button.close') }}</button>
          <div class="ls-clearfix"></div>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import Modal from 'src/app/components/shareds/modal/Modal'
  import CharCounter from 'src/app/components/shareds/char-counter/CharCounter'
  import MoneyInput from 'src/app/components/shareds/money-input/MoneyInput'
  import money from 'src/utils/money'

  export default {
    props: ['value'],
    components: { MoneyInput, Modal, CharCounter },
    data () {
      return {
        money: money,
        types: {
          add: 1,
          discount: 2
        },
        newEntry: {
          type: 0,
          description: '',
          price: ''
        }
      }
    },
    computed: {
      ...mapGetters(['pagination', 'entries', 'contract'])
    },
    methods: {
      ...mapActions(['createEntry', 'destroyEntry']),
      addResource () {
        this.$modalLoader.show()
        this.convertValue()
        return this.createEntry({ entry: Object.assign({}, this.newEntry), contract_id: this.contract.id })
      },
      convertValue () {
        if (this.newEntry.type === '1') this.newEntry.price *= -1
      },
      removeEntry (entry) {
        this.$modalLoader.show()
        this.destroyEntry({ contract_id: this.contract.id, id: entry.id }).then(this.afterDestroyEntry)
      },
      afterDestroyEntry (response) {
        this.$modalLoader.hide()
        this.refreshList()
        if (response.status !== 200) {
          this.value.show = false
        }
      },
      validateBeforeSubmit () {
        this.$validator.validateAll().then(this.submitForm)
      },
      submitForm (success) {
        if (success) {
          this.addResource().then(this.afterAdd)
        }
      },
      cannotBeDeleted (entry) {
        return entry.entry_type === 'proportional_reactivation' || entry.entry_type === 'proportional_addition'
      },
      afterAdd (response) {
        Promise.resolve(this.clearEntry()).then(this.clearErrors)
        this.refreshList()
        if (response.status !== 201) {
          this.value.show = false
        }
        this.$modalLoader.hide()
      },
      refreshList () {
        this.$parent.getEntries()
      },
      clearEntry () {
        this.newEntry.type = 0
        this.newEntry.description = ''
        this.newEntry.price = ''
      },
      clearErrors () {
        this.$validator.reset()
      },
      isDiscount (value) {
        return parseFloat(value) < 0
      }
    }
  }
</script>
<style lang="scss" scoped>
  .btn-action {
    margin: 19px;
    button {
      margin-top: 0;
    }
  }
  .entries-table tr {
    padding: 0;
    margin: 0;
    td {
      padding: 13px;
      margin: 0;
      button {
        margin: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ModalAddEntry.vue?d6d73c68